import {usePayAwardsTrends} from "../../hooks/PayAwardsSearches";
import {Box} from "@mui/material";
import LineChart from "highcharts-react-official";
import Highcharts from "highcharts";
import {useEffect, useState} from "react";
import {generateChartTitle} from "./AwardChartUtils";
import {defaultChartOptions} from "../utils/ChartUtils";

const AwardsTrendLine = ({data, label, filters}) => {
    const [chartSeries, setChartSeries] = useState([]);
    const [chartTitle, setChartTitle] = useState('');
    const [chartColumns, setChartColumns] = useState([]);

    const {trends, isLoading} = usePayAwardsTrends(filters);

    useEffect(() => {

        const columnNames = [];
        const lowerQuartile = [];
        const median = [];
        const upperQuartile = [];
        const average = [];
        const cpi = [];
        const rpi = [];
        const cpih = [];

        if (!isLoading) {
            trends?.trends?.forEach(trend => {
                columnNames.push(trend.label);
                lowerQuartile.push(trend.lowerQuartile);
                median.push(trend.medianQuartile);
                upperQuartile.push(trend.upperQuartile);
                average.push(trend.average);
                cpi.push(trend.cpi);
                rpi.push(trend.rpi);
                cpih.push(trend.cpih);
            });
        }

        const series = [
            {
                name: "Lower Quartile",
                data: lowerQuartile,
            },
            {
                name: "Median",
                data: median,
            },
            {
                name: "Upper Quartile",
                data: upperQuartile,
            },
            {
                name: "Average",
                data: average,
            },
            {
                name: "CPI",
                data: cpi,
            },
            {
                name: "RPI",
                data: rpi,
            },
            {
                name: "CPIH",
                data: cpih,
            },
        ];

        setChartColumns(columnNames);
        setChartSeries(series);
        setChartTitle(generateChartTitle(data, label));

    }, [data, label, isLoading, trends]);

    const options = {
        ...defaultChartOptions(chartTitle),
        chart: {
            type: 'line',
        },
        tooltip: {
            valueSuffix: "%",
        },
        xAxis: {
            title: {
                text: "Effective Date",
            },
            categories: chartColumns,
        },
        yAxis: {
            title: {
                text: "Increase %",
            },
            labels: {
                format: "{value}%",
            }
        },
        series: chartSeries,
    };

    return (
        <Box id="trend_line" name="trend_line">
            <LineChart highcharts={Highcharts} options={options}/>
        </Box>
    );
};

export default AwardsTrendLine;
